import * as React from "react";

function InformationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        fill="white"
        stroke="#3B3B3B"
        strokeWidth="2"
        transform="translate(-2,-2)"
      />
      <path
        d="M13.8792 16.0389C13.9582 16.1993 13.9986 16.3762 13.9969 16.5551C14.0042 16.6168 13.9985 16.6793 13.98 16.7386C13.9616 16.7979 13.9309 16.8527 13.8899 16.8992C13.7776 16.978 13.6403 17.0124 13.5044 16.996H10.142C10.0614 16.8242 10.0176 16.6374 10.0135 16.4476C10.0072 16.3892 10.0136 16.3302 10.032 16.2745C10.0505 16.2189 10.0807 16.1679 10.1206 16.125C10.2108 16.0605 10.3208 16.0301 10.4311 16.0389H11.0094C11.0094 15.4367 11.0094 14.7916 11.0094 14.1141C11.0094 13.0388 11.0094 12.3936 11.0094 12.0495C11.0075 11.7976 10.9677 11.5475 10.8916 11.3075C10.8751 11.2406 10.8433 11.1786 10.7987 11.1263C10.7541 11.074 10.6979 11.0329 10.6346 11.0064C10.4675 10.985 10.2984 10.985 10.1313 11.0064C10.0456 10.8676 10.0011 10.7072 10.0028 10.544C9.991 10.4383 10.0168 10.3317 10.0755 10.2432C10.1343 10.1547 10.2223 10.0898 10.324 10.0601C10.7585 9.98212 11.2003 9.95331 11.6411 9.9741C11.9776 9.9602 12.3146 9.97818 12.6477 10.0279C12.8298 10.0279 12.9368 10.1354 12.9582 10.2429C12.9724 10.3967 12.9724 10.5515 12.9582 10.7053V14.1679C12.9582 14.8453 12.9582 15.4906 12.9582 16.0927L13.8792 16.0389ZM10.8594 8.75897C10.7635 8.67343 10.6885 8.56683 10.6402 8.44748C10.5919 8.32813 10.5717 8.19922 10.581 8.07074C10.5781 7.92485 10.6084 7.7802 10.6696 7.64787C10.7309 7.51554 10.8214 7.39902 10.9344 7.30723C11.2286 7.09172 11.5881 6.98535 11.9517 7.00617C12.2899 6.9744 12.6282 7.066 12.9047 7.26424C12.9962 7.35094 13.0683 7.4562 13.1163 7.57298C13.1643 7.68977 13.1871 7.81543 13.1831 7.94171C13.1878 8.08418 13.1604 8.2259 13.1029 8.35625C13.0455 8.48659 12.9594 8.6022 12.8512 8.69445C12.5417 8.92052 12.1617 9.02735 11.7804 8.99551C11.4552 9.02854 11.1289 8.94475 10.8594 8.75897Z"
        fill="#3B3B3B"
        transform="translate(-2,-2)"
      />
    </svg>
  );
}

export default InformationIcon;
